import React from 'react';

import './styles.scss';
import emptyPic from './img/empty.png';

export default function Empty() {
  return <img className="empty-Page" src={emptyPic} alt="Empty Pic" />;
}



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/Empty/index.js